import { Lightning } from '@lightningjs/sdk';
import AbstractLoginSplitContent, {
  AbstractLoginSplitContentTemplateSpec,
} from '../layout/AbstractLoginSplitContent';
import SignInSection from './SignInSection';

export interface SignInContentTemplateSpec
  extends AbstractLoginSplitContentTemplateSpec {
  email: string;
  Content: {
    LeftSection: typeof SignInSection;
  } & AbstractLoginSplitContentTemplateSpec['Content'];
}

export default class SignInContent extends AbstractLoginSplitContent {
  private _SignInSection = this.getByRef('Content')!.getByRef(
    'LeftSection',
  )! as SignInSection;

  set email(value: string) {
    this._SignInSection.emailValue = value;
  }

  static override _template(): Lightning.Component.Template<AbstractLoginSplitContentTemplateSpec> {
    const { Content } = super._template();

    return {
      Content: {
        ...Content,
        LeftSection: {
          type: SignInSection,
          passSignals: {
            $signInLink: '$signInLink',
            $usePassword: '$usePassword',
            $onButtonHovered: '$onButtonHovered',
            $openKeyboard: true,
            $resetToEmailInput: true,
          },
        },
      },
    };
  }

  override _getFocused() {
    return this._LeftSection;
  }
}
